<div class="dark-theme">
  <div class="header">
    <a class="upgrade" target="_top" [routerLink]="joinUpgradeLink">{{ upgradeJoinButtonText }}</a>
    <span>{{ upgradeLoginCaptionText }}</span>
    <a class="history" target="_top" href="{{appUrl}}/settings/account?t=payment-history">Payment History</a>
  </div>
  <div>
    <tyt-offers-wizard *ngIf="offerLoaded" [offerSet]="offerSet" [step]="step ?? 'pricing'" [offerUUID]="offerUUID" [price]="price" [period]="period" [offer]="offer" [inSettings]="true"></tyt-offers-wizard>
  </div>
</div>